import React, { useState } from "react";
import Select from "react-select";
import {
  FaMapMarkerAlt,
  FaUser,
  FaHeart,
  FaSearch,
  FaFilter,
  FaRedo,
} from "react-icons/fa";
import ProfileSidebar from "../component/ProfileSidebar"; 
import BottomMenu from "../component/BottomMenu";
import NavigateHome from "../component/utils/NavigateHome";
import PageCount from "../component/utils/PageCount";

const AdvancedSearch = () => {
  const [filters, setFilters] = useState({
    profileId: "",
    age: "",
    height: "",
    maritalStatus: "",
    religion: "",
    motherTongue: "",
    community: "",
    location: "",
    education: "",
    interests: "",
    hobby: "",
  });

   // ⭐ NEW STATE
  const [showAppModal, setShowAppModal] = useState(false);
  
  const [showResults, setShowResults] = useState(false);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const maritalOptions = [
    { value: "Single", label: "Single" },
    { value: "Divorced", label: "Divorced" },
    { value: "Widowed", label: "Widowed" },
  ];

  const profiles = [
    {
      id: "BP1023",
      name: "Aarohi Sharma",
      city: "Mumbai",
      age: 26,
      height: "5'5\"",
      maritalStatus: "Single",
      religion: "Hindu",
      motherTongue: "Hindi",
      community: "Brahmin",
      education: "B.Tech (CS)",
      interests: "Music, Travel",
      hobby: "Photography",
      image:
        "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=600",
    },
    {
      id: "BP1078",
      name: "Riya Kapoor",
      city: "Pune",
      age: 24,
      height: "5'4\"",
      maritalStatus: "Single",
      religion: "Sikh",
      motherTongue: "Punjabi",
      community: "Khatri",
      education: "B.Des",
      interests: "Art, Yoga",
      hobby: "Painting",
      image:
        "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=600",
    },
    {
      id: "BP1189",
      name: "Arjun Patel",
      city: "Ahmedabad",
      age: 28,
      height: "5'9\"",
      maritalStatus: "Single",
      religion: "Hindu",
      motherTongue: "Gujarati",
      community: "Patel",
      education: "M.Arch",
      interests: "Fitness, Reading",
      hobby: "Cycling",
      image:
        "https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=600",
    },
  ];

  const filteredProfiles = profiles.filter((p) => {
    return (
      (!filters.profileId ||
        p.id.toLowerCase().includes(filters.profileId.toLowerCase())) &&
      (!filters.age || p.age.toString() === filters.age) &&
      (!filters.height || p.height === filters.height) &&
      (!filters.maritalStatus ||
        p.maritalStatus === filters.maritalStatus.value) &&
      (!filters.religion ||
        p.religion.toLowerCase().includes(filters.religion.toLowerCase())) &&
      (!filters.motherTongue ||
        p.motherTongue
          .toLowerCase()
          .includes(filters.motherTongue.toLowerCase())) &&
      (!filters.community ||
        p.community.toLowerCase().includes(filters.community.toLowerCase())) &&
      (!filters.location ||
        p.city.toLowerCase().includes(filters.location.toLowerCase())) &&
      (!filters.education ||
        p.education.toLowerCase().includes(filters.education.toLowerCase())) &&
      (!filters.interests ||
        p.interests.toLowerCase().includes(filters.interests.toLowerCase())) &&
      (!filters.hobby ||
        p.hobby.toLowerCase().includes(filters.hobby.toLowerCase()))
    );
  });

  // const handleSearch = () => setShowResults(true);

  const handleSearch = () => {
    // Instead of showing results → show Coming Soon modal
    setShowAppModal(true);
  };


  const handleReset = () => {
    setFilters({
      profileId: "",
      age: "",
      height: "",
      maritalStatus: "",
      religion: "",
      motherTongue: "",
      community: "",
      location: "",
      education: "",
      interests: "",
      hobby: "",
    });
    setShowResults(false);
  };

  return (

    <>
    <NavigateHome/>
    
    <PageCount pageName = {"Advance Search"}/>
    <div className="advanced-search-layout">
      <ProfileSidebar />
      <div className="search-content">
        <div className="filter-card shadow-sm p-4 mb-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="fw-bold mb-0">
              <FaFilter className="me-2 text-theme" /> Advanced Search
            </h5>
          </div>

          <div className="row g-2">
            <div className="col-12 col-md-2">
              <input
                type="text" 
                placeholder="Profile ID"
                value={filters.profileId}
                onChange={(e) => handleFilterChange("profileId", e.target.value)}
              />
            </div>

            <div className="col-6 col-md-2">
              <input
                type="number" 
                placeholder="Age"
                value={filters.age}
                onChange={(e) => handleFilterChange("age", e.target.value)}
              />
            </div>

            <div className="col-6 col-md-2">
              <input
                type="text" 
                placeholder="Height (e.g. 5'6\)"
                value={filters.height}
                onChange={(e) => handleFilterChange("height", e.target.value)}
              />
            </div>

            <div className="col-12 col-md-3">
              <Select
                options={maritalOptions}
                placeholder="Marital Status"
                  classNamePrefix="talaash-select"
                value={filters.maritalStatus}
                onChange={(opt) => handleFilterChange("maritalStatus", opt)} 
              />
            </div>

            <div className="col-12 col-md-3">
              <input
                type="text" 
                placeholder="Religion"
                value={filters.religion}
                onChange={(e) => handleFilterChange("religion", e.target.value)}
              />
            </div>

            <div className="col-12 col-md-3">
              <input
                type="text" 
                placeholder="Mother Tongue"
                value={filters.motherTongue}
                onChange={(e) =>
                  handleFilterChange("motherTongue", e.target.value)
                }
              />
            </div>

            <div className="col-12 col-md-3">
              <input
                type="text" 
                placeholder="Location"
                value={filters.location}
                onChange={(e) => handleFilterChange("location", e.target.value)}
              />
            </div>

            <div className="col-12 col-md-3">
              <input
                type="text" 
                placeholder="Education"
                value={filters.education}
                onChange={(e) =>
                  handleFilterChange("education", e.target.value)
                }
              />
            </div>

            <div className="col-12 col-md-3">
              <input
                type="text" 
                placeholder="Interests"
                value={filters.interests}
                onChange={(e) =>
                  handleFilterChange("interests", e.target.value)
                }
              />
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 mt-3">
            <button className="btn btn-primary" onClick={handleSearch}>
              <FaSearch className="me-2" /> Search
            </button>
            <button className="btn btn-outline-secondary" onClick={handleReset}>
              <FaRedo className="me-2" /> Reset
            </button>
          </div>
        </div>

        {showResults && (
          <div className="row g-4">
            {filteredProfiles.length > 0 ? (
              filteredProfiles.map((p) => (
                <div key={p.id} className="col-12 col-sm-6 col-lg-4">
                  <div className="profile-card shadow-sm">
                    <img src={p.image} alt={p.name} className="profile-img" />
                    <div className="profile-info p-3">
                      <h5 className="fw-bold mb-1">{p.name}</h5>
                      <p className="text-muted small mb-1">
                        <FaMapMarkerAlt className="me-1 text-danger" />
                        {p.city} • {p.age} yrs
                      </p>
                      <p className="small text-secondary mb-1">
                        {p.education} • {p.religion}
                      </p>
                      <p className="small about-text text-muted mb-2">
                        {p.interests}
                      </p>
                      <div className="d-flex justify-content-between align-items-center">
                        <button className="btn btn-sm btn-outline-primary">
                          <FaUser /> View
                        </button>
                        <button className="btn btn-sm btn-danger">
                          <FaHeart />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center text-muted mt-5">
                No profiles found matching your criteria.
              </p>
            )}
          </div>
        )}
      </div>
    </div>


 {/* ⭐ COMING SOON MODAL */}
      {showAppModal && (
        <>
          <div
            className="confirm-modal-backdrop"
            onClick={() => setShowAppModal(false)}
          ></div>

          <div className="confirm-modal-box">
            <div className="confirm-title">Coming Soon 🚀</div>

            <div className="confirm-text text-center">
              <strong>Advance Search</strong> will be live soon!  
              <br />
              Thank you for your patience ❤️
            </div>

            <div className="confirm-actions">
              <button
                className="confirm-btn confirm-yes"
                onClick={() => setShowAppModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </>
      )}


<BottomMenu/>
</>
  );
};

export default AdvancedSearch;
